export const CREATE_PARTNER_USER = "partnerUser/CREATE_PARTNER_USER";
export const CREATE_PARTNER_USER_SUCCESS = "partnerUser/CREATE_PARTNER_USER_SUCCESS";
export const CREATE_PARTNER_USER_ERROR = "partnerUser/CREATE_PARTNER_USER_ERROR";
